import React from 'react';

let config = require('config');

class About extends React.Component {

  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {
  }

  render() {
    document.title = "ABOUT | " + config.default.SITE_NAME
    return (
      <div id="about" className="main">
        <div className="about_inner">
          <div className="about_section">
            <div className="about_section__statement" dangerouslySetInnerHTML={{ __html:"広告会社と映像制作会社の垣根を取り払い、<br class='m_n'>戦略から実装までをひとつなぎで形にする。<br>それがHAKUHODO CABINです。" }} />
            <div className="about_section__body" dangerouslySetInnerHTML={{ __html:"広告の世界では戦略や統合という言葉が広がり、作り手の関わり方も多様化しています。<br>そんな中で私たちが大切にしたいのは、すべての仕事において、手仕事で応えるという姿勢です。<br>映像で、言葉で、企業や商品の持つ意味を形にするその最後の瞬間まで、共に悩み苦しみ抜ける存在でありたい。遠回りを惜しまず、むしろその先にこそ効率ではたどり着けない場所があると信じて、ひたむきに頭と手を動かしつづけます。" }}></div>
          </div>
          <div className="about_section">
            <div className="about_section__title">CORPORATE DATA</div>
            <div className="about_section__body data">
              <dl className="body__block">
                <dt>会社名</dt>
                <dd>株式会社博報堂キャビン（HAKUHODO CABIN Inc.）</dd>
              </dl>
              <dl className="body__block">
                <dt>所在地</dt>
                <dd>東京都渋谷区神宮前2-14-18<span><a href="https://goo.gl/maps/UsTQTEX26NseDW397" target="_blank">Google Maps</a></span></dd>
              </dl>
              <dl className="body__block">
                <dt>代表取締役</dt>
                <dd>須之内 元也</dd>
              </dl>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

About.displayName = 'About';
About.propTypes = {};
About.defaultProps = {};

export default About;



// WEBPACK FOOTER //
// ./components/About.js